import window from 'window-or-global';
import { bind } from '@confluence-classic/confluence-event_DO_NOT_USE';
import { CONTEXT_PATH } from '@confluence-classic/confluence-urls';
// TODO: remove jquery from here and from webpack config once CONFDEV-52616 is done.
// eslint-disable-next-line no-restricted-imports
import $ from 'jquery';

const SkitchPaste = {
	pasteHandler(uri, node, done) {
		if (uri.host === 'www.skitch.com' || uri.host === 'skitch.com') {
			$.get(`${CONTEXT_PATH}/rest/autoconvert/1.0/skitchembed?url=${uri.source}`, (data) => {
				if (data && data.url) {
					done(
						$(
							`<img class="confluence-embedded-image confluence-external-resource" src="${data.url}" data-image-src="${data.url}"/>`,
						)[0],
					);
				} else {
					done();
				}
			});
		} else {
			done();
		}
	},
};

export default function () {
	bind('init.rte', () => {
		window.tinymce.plugins.Autoconvert.autoConvert.addHandler(SkitchPaste.pasteHandler);
	});
}
